export const getBrowser = () => {
  const userAgent = navigator.userAgent;
  let template = null;
  let match = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

  if (/trident/i.test(match[1])) {
    template = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
    return "IE " + (template[1] || "");
  }

  if (match[1] === "Chrome") {
    template = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
    if (template != null) return template.slice(1).join(" ").replace("OPR", "Opera");
  }

  match = match[2] ? [match[1], match[2]] : [navigator.appName, navigator.appVersion, "-?"];
  if ((template = userAgent.match(/version\/(\d+)/i)) != null) match.splice(1, 1, template[1]);
  return match.join(" ");
};
export const isOldBrowser = () => {
  const str = getBrowser();
  const browser = str.substring(0, str.indexOf(" "));
  const version = parseInt(str.substring(str.indexOf(" ")).trim());
  return browser === "Chrome" && version < 70 || browser === "Firefox" && version < 53 || browser === "Safari" && version < 5 || browser === "IE" || browser === "Opera" && version < 52;
};